//
//
//
//
//
//
//
//
//

import Vue from 'vue';

export default {
  props: { onClick: Function, color: String },
};



// WEBPACK FOOTER //
// ./scripts/vue/burger-menu/BurgerMenuIcon.vue